export enum EGender {
  Woman = 'woman',
  Man = 'man',
}

export type TReview = {
  id: number;
  name: string;
  shortReview: string;
  review: string[];
  gender: EGender;
  moreInfo: string;
};
